import { createContext, useContext } from 'react'

import {
  ClusterCluster,
  ComputeEngineComparisonReportDataValues1
} from '@clinic/client'

export interface OrgAndClusterType {
  isLoading: boolean
  orgId?: string
  orgName?: string
  cluster1?: ClusterCluster
  cluster2?: ClusterCluster
}

export const TimeRangeContext =
  createContext<ComputeEngineComparisonReportDataValues1>(null as any)

export const OrgAndClusterContext = createContext<OrgAndClusterType>(
  null as any
)

export const useOrgAndCluster = () => {
  return useContext(OrgAndClusterContext)
}
